import { render, staticRenderFns } from "./PointExchangeProductItem.vue?vue&type=template&id=dcb6df02&"
import script from "./PointExchangeProductItem.vue?vue&type=script&lang=js&"
export * from "./PointExchangeProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports